import { Button } from '@mui/material';
import './voucher.scss';
import { output } from '../../settings/themeSettings';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { fetchVoucher } from '../../data/slices/voucherSlice';
import { useParams } from 'react-router';
import { PDFViewer } from '@react-pdf/renderer';
import VoucherPDF from '../../components/vouvherPDF/VoucherPDF';
import { fetchCircuit } from '../../data/slices/circuitSlice';

const Vouchers = (props) => {

    const { voucher, voucherFetchStatus } = useSelector((state) => state.vouchers);
    const [dossier, setDossier] = useState({});
    const dispatch = useDispatch();
    const { id, vid } = useParams();

    useEffect(() => {
        dispatch(fetchVoucher(vid));
    }, [vid, dispatch]);

    useEffect(() => {
        if (voucher) {
            fetchCircuit(id)
                .then((response) => {
                    const resp = response.data;
                    output(resp);
                    setDossier(resp);
                }).catch((err) => {
                    output(err);
                });
        }
    }, [voucher, id]);

    const sendVoucherEmail = () => {
        output(voucher);
        const ref = dossier?.reference ?? '----';
        const hotel = voucher?.prestataire?.nom ?? '----';

        // Lire les données depuis voucher.sejours[]
        const sejours = voucher?.sejours || [];

        // Trier par date de début
        const sorted = [...sejours].sort((a, b) => new Date(a.dateDebut) - new Date(b.dateDebut));

        // Plage de dates globale
        const dateDebut = sorted.length > 0 ? sorted[0].dateDebut : null;
        const dateFin   = sorted.length > 0 ? sorted[sorted.length - 1].dateFin : null;

        // Pax total (conforme au rooming si présent, sinon somme des groupes, sinon séjour)
        const pax = (dossier?.rooming?.length > 0) ? dossier.rooming.length :
                    ((dossier?.groups?.length > 0) ? dossier.groups.reduce((acc, g) => acc + (Number(g.pax) || 0), 0) :
                    (sorted.length > 0 ? (sorted[0].pax ?? '----') : '----'));

        // Régime (premier séjour, ou liste unique)
        const regimes = [...new Set(sorted.map(s => s.regime).filter(Boolean))];
        const regime = regimes.length > 0 ? regimes.join(' / ') : '----';

        // Catégorie (première ou liste unique)
        const categories = [...new Set(sorted.map(s => s.categorieChambre).filter(Boolean))];
        const categorie = categories.length > 0 ? categories.join(' / ') : '----';

        // Types de chambres — agrégés depuis tous les séjours
        const typeChambres = sorted.map(s => s.typeChambre).filter(Boolean).join(' - ');
        const typeChambre = typeChambres || '----';

        // Formatage date lisible : "01 JUIN 2026"
        const formatDateLong = (dateStr) => {
            if (!dateStr) return 'null';
            const d = new Date(dateStr);
            if (isNaN(d)) return dateStr;
            return d.toLocaleDateString('fr-FR', { day: '2-digit', month: 'long', year: 'numeric' }).toUpperCase();
        };

        // ── Rooming ──
        const rooming = dossier?.rooming || [];
        let roomingText = '';
        if (rooming.length > 0) {
            roomingText = '\n\nRooming :\n';
            rooming.forEach((r, i) => {
                const civilite = r.civilite ? `${r.civilite} ` : '';
                const nom = r.nom || '';
                const prenom = r.prenom || '';
                roomingText += `  ${i + 1}. ${civilite}${prenom} ${nom}\n`;
            });
        }

        const body = `Bonjour,

Nous vous prions de réserver pour le dossier cité en référence.

Détails de la réservation :

Référence : ${ref}
Hôtel : ${hotel}
Dates : Du ${formatDateLong(dateDebut)} au ${formatDateLong(dateFin)}
Pax : ${pax}
Régime : ${regime}
Type de chambre : ${typeChambre}
Catégorie : ${categorie}${roomingText}
Dans l'attente de votre confirmation avec la pro forma.

Cordiales salutations`;

        const email = voucher.prestataire?.courriel ?? "";
        const subject = `[RÉSERVATION] Dossier N° ${ref} — ${hotel}`;
        window.location.href = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    };

    return (<div className="circuit-page">
        <div className="header">
            <div className="title">
                Détail du Voucher
            </div>

            <Button
                variant="contained"
                color="secondary"
                disabled={!(voucher && voucher.prestataire?.courriel)}
                onClick={sendVoucherEmail}
            >
                Envoyer par E-mail (Outlook)
            </Button>
        </div>

        {
            (voucherFetchStatus === 'loading') ?
                <div className="loader-container">
                    <span className="loader"></span>
                </div>
                :
                <PDFViewer style={{ width: '100%', height: '100vh' }}>
                    <VoucherPDF voucher={voucher} dossier={dossier} />
                </PDFViewer>
        }

    </div>);
};

export default Vouchers;
